// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"59":"46a1803b","173":"cae070cd","251":"06b90ca4","754":"934bbfa4","813":"9f56b414"}[chunkId] + ".chunk.css";
};